import React from "react";
import { PortfolioTabNavigation } from "./components";
import style from "./PortfolioSpace.module.css";

export default function PortfolioSpace() {
	return (
		<div className={style.mainContainer}>
			<PortfolioTabNavigation />
		</div>
	);
}
